import { render, staticRenderFns } from "./DevolucaoTotalTroca.vue?vue&type=template&id=4c25eefb&scoped=true&"
import script from "./DevolucaoTotalTroca.vue?vue&type=script&lang=js&"
export * from "./DevolucaoTotalTroca.vue?vue&type=script&lang=js&"
import style0 from "./DevolucaoTotalTroca.vue?vue&type=style&index=0&id=4c25eefb&scoped=true&lang=css&"
import style1 from "./DevolucaoTotalTroca.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25eefb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
